// extracted by mini-css-extract-plugin
module.exports = {"secondaryHeading":"index-module--secondaryHeading--36a4p"};